import {Component, input, Input, InputSignal, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
    imports: [
        RouterLink,
    ],
  host: { id: 'unique-id' }
})
export class LogoComponent {

  isLogin: InputSignal<boolean> = input(false);
  color = input<string>('');
  innerPage = input<boolean>(false);
  @Input() height: string = '40px';
  constructor() { }

}
